import React from "react";
import useTimer from "../hooks/useTimer";
import collectionStore from "../stores/collectionStore";
import activeStore from "../stores/activeStore";
import MainStore from "../stores/MainStore";
import boxStore from "../stores/boxStore";

const OnlineStatus = () => {
  const { player, create, detailedView } = MainStore();
  const { general, open, saved } = collectionStore();
  const { goal, box, mood, focus } = activeStore();
  const { relatedBoxTypes, boxTypeOverview } = boxStore();
  const timer = useTimer();
  return (
    <div
      onClick={() => {
        console.log(" | open - ", open, " | saved - ", saved);
        console.log(" plaser- ", player);
      }}
      className="divRow"
      style={{
        backgroundColor: "#5f5f5f",
        width: "100%",
        justifyContent: "space-between",
        alignContent: "center",
        padding: "5px",
      }}
    >
      <img
        className="icon25"
        style={{ marginLeft: "5px" }}
        src={
          player?.online ? "/icons/icon_online.png" : "/icons/icon_offline.png"
        }
      />
      <div
        className="divRow"
        style={{
          flex: 1,
          justifyContent: "center",
          textAlign: "center",
          backgroundColor: "#2f2f2f",
          marginLeft: "25px",
          marginRight: "25px",
          padding: "2px",
          borderRadius: "1rem/1rem",
          border: "1px solid white",
        }}
      >
        <div className="textBoldWhite" style={{ flex: 1 }}>
          {player?.playing ? "Playing" : "Paused"}
        </div>
        <div
          className="textBoldWhite"
          style={{ fontSize: "12px", marginRight: "5px" }}
        >
          {Math.round(timer.tick / 60) == 1
            ? `${Math.round(timer.tick / 60)} min`
            : `${Math.round(timer.tick / 60)} mins`}
        </div>
      </div>
    </div>
  );
};

export default OnlineStatus;
